import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { PrimeNGConfig } from 'primeng/api';
import { MessageService } from 'primeng/api';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { allSchemes, Scheme } from '../../../shared/data/allSchemes';
import { environment } from '../../../../environments/environment';
import { ApiService } from '../../../services/api.service';
import { ActivatedRoute } from '@angular/router';
import { FileUpload } from 'primeng/fileupload';
import { Subscription } from 'rxjs';
import { UploadService } from '../../../services/upload/upload.service';

@Component({
  selector: 'app-aip',
  standalone: false,
  templateUrl: './aip.component.html',
  styleUrl: './aip.component.scss',
})
export class AIPComponent implements OnInit {
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @Input() id: any;
  @Input() getUrl: string;
  @Input() postUrl: string;
  @Output() stepCompleted = new EventEmitter<void>();
  isEditorDisabled: boolean = false;
  aip: FormGroup;
  apiUrl = environment.APIUrl;
  selectedProduct: any;
  proposalForm: FormGroup;
  challengeForm: FormGroup;
  payload: any;
  uploadedFiles: any;
  aipId: any;
  aipData: any;
  uploadedDocs: any;
  @Input() step: any;
  @Input() schemeType: any;
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
  @Input() isEditable;
  @Input() stepDetails: any;
 data:any
  private subscriptions = new Subscription();
  userID: any;
  lable: string;
  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private api: ApiService,
    private route: ActivatedRoute,
    private uploadService: UploadService
  ) {
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }

  ngOnInit(): void {
    this.aip = this.fb.group({
      file_number: ['', Validators.required],
      file_name: ['', Validators.required],
      document: [''],
    });
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      const step_id = params['step'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName,
        step_id: step_id,
      };
      // Call after payload is set
      this.getCurrentStepApi();
      this.lable = ['makeI','makeII'].includes(this.schemeType) ? 'Presentation wrt AIP by MAKE collegiate' : 'Presentation wrt AIP';
    });
  }
 ngAfterViewInit() {
    setTimeout(() => {
      if (this.stepDetails?.can_edit ) {
        this.isEditorDisabled = false;
        this.aip.enable();
      } else {
        this.isEditorDisabled = true;
        this.aip.disable();
      }
      // this.rebuildEditor();
    }, 3000);
  }
  getCurrentStepApi(){
    // Use this.id (Input property) which is always available, fallback to payload.step_id
    const stepId = this.id || this.payload?.step_id;
    if (!stepId || !this.payload?.proposal_id) {
      console.warn('Missing stepId or proposal_id, cannot fetch AIP data');
      return;
    }
    this.api.getAPI(this.getUrl+stepId+'&proposal_step__proposal='+this.payload.proposal_id).subscribe((res: any) => {
      this.aipData = res;
      if (res && res.length > 0) {
        this.remark = res[0].comment || '';
        this.aipId = res[0].id;
      }
    });
  }

  onDocumentUpload(data:any){
    const formData = new FormData();
    // Use this.id instead of this.data.need_generation[0]?.proposal_step
    formData.append('proposal_step', this.id);
    formData.append('name', data.name);
    formData.append('description', data.description);
    formData.append('file', data.file);

    // Use the proper API endpoint instead of uploadService
    this.api.postAPI(this.postUrl, formData).subscribe({
      next:(res:any)=>{
        this.messageService.add({severity:'success',summary:'Success',detail:'Document uploaded successfully'});
        this.getCurrentStepApi();
      },
      error: (err) => {
        console.error('❌ Upload failed:', err);
        this.messageService.add({severity:'error',summary:'Error',detail:'Document upload failed'});
      }
    });
  }

  onDocumentEdited(updatedDoc: any) {
    console.log('✏️ Edited document from child:', updatedDoc);

    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('name', updatedDoc.name);
    formData.append('type_doc', updatedDoc.type_document);
    formData.append('description', updatedDoc.description);

    if (updatedDoc.file instanceof File) {
      formData.append('file', updatedDoc.file);
    }

    this.api.putAPI(`${this.postUrl}${updatedDoc.id}/`, formData).subscribe({
      next: (response: any) => {
        console.log('✅ Document updated successfully:', response);
        this.getCurrentStepApi();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Document updated successfully',
        });
      },
      error: (err) => {
        console.error('❌ Update failed:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Document update failed',
        });
      },
    });
  }

  onDocumentDeleted(docId: number) {
    console.log('🗑️ Deleted document ID from child:', docId);

    this.api.deleteAPI(`${this.postUrl}${docId}/`).subscribe({
      next: (res: any) => {
        console.log('delete uploadData', res);
        this.getCurrentStepApi();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Document deleted successfully',
        });
      },
      error: (err) => {
        console.error('❌ Delete failed:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Document deletion failed',
        });
      }
    });
  }

remark:any
onSubmit(){
  // if (!this.remark || this.remark.trim() === '') {
  //   this.messageService.add({
  //     severity: 'warn',
  //     summary: 'Warning',
  //     detail: 'Please enter remarks before saving',
  //   });
  //   return;
  // }

  // Use this.id instead of this.payload.step_id
  const stepId = this.id || this.payload?.step_id;
  
  if(this.aipId || (this.aipData && this.aipData[0]?.id)){
    const updateId = this.aipId || this.aipData[0].id;
    this.api.putAPI('/revenue/aip-details/'+updateId+'/', {comment: this.remark, proposal_step: stepId}).subscribe((res: any) => {
      this.messageService.add({severity:'success',summary:'Success',detail:'Remarks saved successfully'});
    }, error => {
      console.error('Error updating remarks:', error);
      this.messageService.add({severity:'error',summary:'Error',detail:'Failed to save remarks'});
    });
    return;
  }
  const payload={
    comment: this.remark,
    proposal_step: stepId,
  }
 const sub = this.api.postAPI('/revenue/aip-details/', payload).subscribe((res: any) => {
  this.messageService.add({severity:'success',summary:'Success',detail:'Remarks saved successfully'});
 }, error => {
  console.error('Error saving remarks:', error);
  this.messageService.add({severity:'error',summary:'Error',detail:'Failed to save remarks'});
 })
 this.subscriptions.add(sub);
}

  goToNextStep() {
    this.stepCompleted.emit();
  }

  generatePDF() {
    const data: any[] = [
      { key: 'Proposal Name', value: this.payload.proposal_name },
      { key: 'Remarks', value: this.remark || '' },
    ];

    const payload = {
      url: '/revenue/need/version-control/',
      data,
    };

    this.generatePDFEmitter.emit(payload);
  }

}
